import { observer } from 'mobx-react-lite'
import rootStore from '@/app/store'
import cx from 'classnames'
import styles from './index.module.css'

interface NoveltyIndicatorProps {
  targetKey: string
  position?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left'
}

export const NoveltyIndicator = observer(
  ({ targetKey, position = 'top-right' }: NoveltyIndicatorProps) => {
    const { noveltyFeedback } = rootStore

    if (!noveltyFeedback.isNew(targetKey)) {
      return null
    }

    return (
      <div className={cx(styles.indicator, styles[position])}>
        <span className="sr-only">Nueva funcionalidad</span>
      </div>
    )
  },
)
